import { render, staticRenderFns } from "./Div.vue?vue&type=template&id=8d6d8f0c&"
import script from "./Div.vue?vue&type=script&lang=js&"
export * from "./Div.vue?vue&type=script&lang=js&"
import style0 from "./Div.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports